import { Directive, inject, input, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

import { isNull } from 'lodash-es';

@Directive({
  selector: '[redRequired]',
  standalone: true
})
export class RequiredDirective implements OnChanges {
  readonly redRequired = input(false);

  private readonly ngControl = inject(NgControl);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['redRequired']) {
      const control = this.ngControl.control;
      if (!isNull(control)) {
        if (this.redRequired()) {
          control.addValidators(Validators.required);
        } else {
          control.removeValidators(Validators.required);
        }
        control.updateValueAndValidity({ emitEvent: false });
      }
    }
  }
}
